const openModal = el => {

  let emailInput = document.querySelector('.brochureDownloadModal__content input');
  el.classList.add('brochureDownloadModal__overlay--active');

  if (typeof emailInput != "undefined" && emailInput != null) {
    emailInput.focus();
  }

};

function DownloadBrochure (el) {

  let brochureTrigger = document.querySelectorAll('.downloadBrochureBtn');
  let generatedDownloadLink = document.querySelector('.dlm-nf-download-link');
  let closeBrochureModal = document.querySelector('.brochureDownloadModal__closeModal');
  let hasErrors = document.querySelector('.brochureDownloadModal__content .gfield_error');

  if (typeof generatedDownloadLink != "undefined" && generatedDownloadLink != null) {
    openModal(el);
  }

  if (typeof hasErrors != "undefined" && hasErrors != null) {
    openModal(el);
  }

  Array.prototype.forEach.call(brochureTrigger, (trigger) => {
    trigger.addEventListener('click', () => {
      openModal(el);
    })
  });

  closeBrochureModal.addEventListener('click', () => el.classList.remove('brochureDownloadModal__overlay--active'));

}

export default DownloadBrochure;


// WEBPACK FOOTER //
// ./src/js/app/components/DownloadBrochure.js